var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{style:({ marginBottom: '0px' })},[_vm._v(_vm._s(_vm.displayValue))]),_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }